import Main from "./Main.svelte";

function initSpyDashboard(wrapId, params = {}) {
	return new Main({
		target: document.getElementById(wrapId),
		props: params
	});
}

window.initSpyDashboard = initSpyDashboard;